import {
  SHOPCODE_CLOSE_POPUP,
  SHOPCODE_OPEN_SUCCESS,
  SHOPCODE_OPEN_FAIL,
} from "../actions/types";

const INIT_STATE = {
  displayPopupSuccess: false,
  displayPopupFail: false,
  displayMessage: "",
};

export default (state = INIT_STATE, action = {}) => {
  switch (action.type) {
    case SHOPCODE_CLOSE_POPUP:
      document.body.classList.remove("modal-open");
      return INIT_STATE;
    case SHOPCODE_OPEN_SUCCESS:
      document.body.classList.add("modal-open");
      return {
        ...state,
        displayPopupSuccess: true,
      };
    case SHOPCODE_OPEN_FAIL:
      document.body.classList.add("modal-open");
      return {
        ...state,
        displayPopupFail: true,
        displayMessage: action.payload,
      };
    default:
      return state;
  }
};
